import { useQuery } from "@tanstack/react-query";

import { werkvoorraadApi } from "@/lib/api";
import type { WerkvoorraadTellersAntwoord } from "@/types/api";

/**
 * Sidebar-tellers van de kanaaloverstijgende werkvoorraad
 * (inbox-herindeling 18-08). Zelfde ritme als de andere tellers (60s)
 * zodat de badges nooit lang achterlopen op de lijst.
 */
export function useWerkvoorraadTellers(opties?: { enabled?: boolean }) {
  return useQuery<WerkvoorraadTellersAntwoord>({
    queryKey: ["werkvoorraad", "tellers"],
    queryFn: () => werkvoorraadApi.tellers(),
    refetchInterval: 60_000,
    // Ook doortellen op een achtergrond-tabblad (08-09): react-query
    // pauzeert zijn interval standaard zodra het document verborgen is,
    // en dan zou de portaalmelding (geluid + titel-teller) juist nooit
    // komen op het moment dat je hem nodig hebt — als je in een ander
    // tabblad zit. Eén licht verzoek per minuut.
    refetchIntervalInBackground: true,
    staleTime: 15_000,
    enabled: opties?.enabled ?? true,
  });
}
